<main class="sw-tpl-page">
  <div class="sw-page-header">
    <h1 class="sw-page-title m-0">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
      </svg>
      Dynamic Form
    </h1>
    <div class="d-flex align-items-center gap-2 flex-wrap">
    <button type="button" class="sw-page-manual" (click)="manual.open('dynamic-form-page')" title="How to use this page">
      <span class="sw-page-manual-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
        </svg>
      </span>
      <span class="sw-page-manual-copy">
        <span class="sw-page-manual-label">Manual</span>
        <span class="sw-page-manual-sub">How this page works</span>
      </span>
      <svg class="sw-page-manual-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M5 12h14"></path>
        <path d="m12 5 7 7-7 7"></path>
      </svg>
    </button>
    <button type="button" class="sw-header-btn sw-header-btn--primary" (click)="openFormBuilder()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
      New Form
    </button>
    </div>
  </div>

  <div class="sw-tpl-intro">
    <div class="sw-tpl-intro-title">Your forms</div>
    <div class="sw-tpl-intro-subtitle">Build a new dynamic form or manage the sites that use an existing one.</div>
  </div>

  <div class="sw-tpl-scroll">
    @if (!isLoading) {
      @if (formsList.length > 0) {
        <div class="sw-tpl-grid">
          @for (form of formsList; track form._id; let i = $index) {
            <div class="sw-tpl-card" [class.sw-tpl-card--incident]="isIncidentForm(form)">
              <div class="sw-tpl-card-head">
                @if (renamingFormId !== form._id) {
                  <div class="sw-tpl-card-titlerow">
                    <div class="sw-form-card-headleft">
                      <span class="sw-form-card-icon" [class.sw-form-card-icon--incident]="isIncidentForm(form)">
                        @if (isIncidentForm(form)) {
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
                            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                          </svg>
                        } @else {
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                          </svg>
                        }
                      </span>
                      <div class="sw-tpl-card-name text-capitalize">{{ getFormDisplayName(form, i) }}</div>
                    </div>
                    <div class="d-flex align-items-center gap-1 flex-shrink-0">
                      @if (isIncidentForm(form)) {
                        <span class="sw-tpl-badge">Incident</span>
                      }
                      <button type="button" class="sw-form-rename-trigger" (click)="startRename(form, i)"
                        ngbTooltip="Rename form" placement="bottom" aria-label="Rename form">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                } @else {
                  <div class="sw-form-rename-row">
                    <input type="text" class="sw-modal-input" [(ngModel)]="renameDraft"
                      (keydown.enter)="saveRename(form, i)" (keydown.escape)="cancelRename()"
                      [disabled]="isRenameSaving" />
                    <button type="button" class="sw-tpl-ghost-btn" (click)="saveRename(form, i)"
                      [disabled]="isRenameSaving" aria-label="Save name">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </button>
                    <button type="button" class="sw-tpl-ghost-btn sw-tpl-ghost-btn--danger" (click)="cancelRename()"
                      [disabled]="isRenameSaving" aria-label="Cancel rename">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>
                }
                <div class="sw-tpl-card-desc">{{ getFormPreview(form) }}</div>
              </div>

              <div class="sw-form-card-body">
                <span class="sw-form-meta-pill">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="8" y1="6" x2="21" y2="6"></line>
                    <line x1="8" y1="12" x2="21" y2="12"></line>
                    <line x1="8" y1="18" x2="21" y2="18"></line>
                    <line x1="3" y1="6" x2="3.01" y2="6"></line>
                    <line x1="3" y1="12" x2="3.01" y2="12"></line>
                    <line x1="3" y1="18" x2="3.01" y2="18"></line>
                  </svg>
                  {{ getFormFieldCount(form) }} fields
                </span>
                @if (isIncidentForm(form)) {
                  <span class="sw-form-meta-pill sw-form-meta-pill--muted">System managed</span>
                }
              </div>

              <div class="sw-tpl-footer">
                @if (isIncidentForm(form)) {
                  <button type="button" class="sw-tpl-primary-btn" (click)="editForm(form)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                    </svg>
                    Edit form template
                  </button>
                } @else {
                  <button type="button" class="sw-tpl-primary-btn" (click)="viewForm(form)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M3 21h18"></path>
                      <path d="M5 21V7l8-4v18"></path>
                      <path d="M19 21V11l-6-4"></path>
                    </svg>
                    Manage Site
                  </button>
                  <button type="button" class="sw-tpl-ghost-btn" (click)="editForm(form)" ngbTooltip="Edit Form"
                    placement="top">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                    </svg>
                  </button>
                  <button type="button" class="sw-tpl-ghost-btn sw-tpl-ghost-btn--danger" (click)="deleteForm(form, i)"
                    ngbTooltip="Delete Form" placement="top" [disabled]="isDeleting[form._id]">
                    @if (isDeleting[form._id]) {
                      <span class="spinner-border spinner-border-sm"></span>
                    } @else {
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      </svg>
                    }
                  </button>
                }
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="sw-form-empty">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
          </svg>
          <p class="sw-form-empty-title">No forms yet</p>
          <p class="sw-form-empty-subtitle">Create your first dynamic form to get started.</p>
          <button type="button" class="sw-header-btn sw-header-btn--primary" (click)="openFormBuilder()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            New Form
          </button>
        </div>
      }
    } @else {
      <div class="sw-tpl-grid">
        @for (s of [0,1,2,3,4,5]; track s) {
          <div class="sw-tpl-card">
            <div class="sw-tpl-card-head">
              <app-skeleton width="55%" height="18px"></app-skeleton>
              <app-skeleton width="80%" height="12px" margin="0.5rem 0 0"></app-skeleton>
            </div>
            <div class="sw-form-card-body">
              <app-skeleton width="30%" height="24px" borderRadius="999px"></app-skeleton>
            </div>
            <div class="sw-tpl-footer">
              <app-skeleton width="100%" height="36px" borderRadius="8px"></app-skeleton>
              <app-skeleton width="2.25rem" height="2.25rem" borderRadius="8px"></app-skeleton>
            </div>
          </div>
        }
      </div>
    }

    <!-- The client portal's incident categories, below the app's own forms. Hidden for now (see
         showIncidentCategories); the section and its API calls are untouched. -->
    @if (showIncidentCategories) {
    <app-php-category-section></app-php-category-section>
    }
  </div>
</main>

<!-- Manage sites drawer -->
<sw-drawer [(visible)]="sitesPanelOpen" title="Manage sites in this form" width="30rem" (hide)="closeSitesPanel()">
  <div drawer-body>
    <label class="sw-drawer-label d-inline-flex align-items-center gap-1">
      Select Sites
      <span class="sw-hint-icon" role="button" tabindex="0" title="How sites are attached to a form"
        (click)="$event.stopPropagation(); manual.open('form-sites')" (keydown.enter)="$event.stopPropagation(); manual.open('form-sites')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 16v-4"></path>
          <path d="M12 8h.01"></path>
        </svg>
      </span>
    </label>
    <sw-select [multiple]="true" [options]="allSite" optionLabel="site_name" optionValue="_id"
      [(ngModel)]="selectedSites" (selectionChange)="onSelectedSitesChange($event)" placeholder="Select Sites"
      filterBy="site_name" [loading]="isLoadingSites">
    </sw-select>
  </div>

  <div drawer-actions class="sw-side-panel-actions">
    <button type="button" class="sw-modal-btn sw-modal-btn--discard" (click)="closeSitesPanel()">Discard</button>
    <button type="button" class="sw-modal-btn sw-modal-btn--update" (click)="saveSelectedSites()"
      [disabled]="savingSites">
      @if (savingSites) { <span class="spinner-border spinner-border-sm"></span> }
      Save
    </button>
  </div>
</sw-drawer>
